import * as React from 'react';
import { useTranslation } from 'next-i18next';

import { FormLabelWrapper, Heading } from '@restworld/ui-ds-base';

import { WizardStepProps } from '../../worker-application-wizard.types';
import WizardTextInput from '../wizard-text-input';

export const WizardTwelfthStep: React.FunctionComponent<WizardStepProps> = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <WizardTextInput
        label={t('common:cover_letter')}
        placeholder={t('onboarding-page:describe_in_1600_characters')}
        id="presentation"
        type="textarea"
        testId="cover-letter-input"
      />
      <FormLabelWrapper label={t('onboarding-page:why_show_up')}>
        <Heading size={6} weight="normal">
          {t('onboarding-page:increase_your_interview_chances')}
        </Heading>
      </FormLabelWrapper>
      <WizardTextInput
        label={t('onboarding-page:why_are_you_looking_for_work')}
        placeholder={t('onboarding-page:describe_your_reasons_for_looking_for_work')}
        id="motivation_text"
        type="textarea"
        testId="motivation-input"
      />
    </div>
  );
};
export default WizardTwelfthStep;
